/**
 * These values match the backend keys that are returned from the missions endpoint
 */
export enum UploadType {
  RegularAndRtk = 'scan',
  Ppk = 'ppks',
  Lidar = 'lidar',
  Pano = 'pano',
}
